/* global $:true dataLayer:true */
/**
 * Analytics Trigger
 *
 * Send google analytics on element events.
 *
 * @example
 *    <input
 *        type="button"
 *         data-commerce-analytics-trigger
           data-commerce-analytics-trigger-on="click"
           data-commerce-analytics-trigger-groupname="products"
           data-commerce-analytics-trigger-event="productClick"
           data-commerce-analytics-trigger-action="click"
           data-commerce-analytics-trigger-name="#40 Flat fold handle bag"
           data-commerce-analytics-trigger-id="C486S0054"
           data-commerce-analytics-trigger-brand="Stratco"
           data-commerce-analytics-trigger-price="232.00"
           data-commerce-analytics-trigger-category="Carry Bags">
 *
 *    <input
 *        type="button"
 *         data-commerce-analytics-trigger
           data-commerce-analytics-trigger-on="click"
           data-commerce-analytics-trigger-groupname="products"
           data-commerce-analytics-trigger-event="productClick"
           data-commerce-analytics-trigger-action="click"
           data-commerce-analytics-trigger-name="#40 Flat fold handle bag"
           data-commerce-analytics-trigger-id="C486S0054"
           data-commerce-analytics-trigger-brand="Stratco"
           data-commerce-analytics-trigger-price="232.00"
           data-commerce-analytics-trigger-category="Carry Bags"
           data-commerce-analytics-trigger-dynamic="quantity:#quantity:1">

    Dynamic Format
    1. Field Name
    2. Field selector
    3. Default value if selector value is empty (optional)
* @example
    data-commerce-analytics-trigger-dynamic="quantity:#quantity:1"
 */

import debug from "debug";
import plugin from '../../lib/plugin';

const ELEMENT_SELECTOR = '[data-commerce-analytics-trigger]';
const MODULE_NAME = 'app.core/modules/commerce-analytics-trigger';
const log = debug(MODULE_NAME);
const ZERO = 0;


class CommerceAnalyticsTriggerPlugin {

    constructor (element, options) {
        this.element = element;
        this.options = options;
        this.$element = $(element);
        this.watching = null;
        this.$nodeType = this.$element.get(ZERO).nodeType;
        this.isFormField = ['input', 'textarea', 'select', 'button'].includes(this.$nodeType);
        log('CommerceAnalyticsTriggerPlugin', element);

        this.watch();
        log('ready', this.$element);
    }

    watch () {
        this.watching = this.$element.on(this.options.on, this.trigger.bind(this));
        log('watching', this.$element);
    }

    unwatch () {
        this.$element.off(this.watching);
        log('unwatched', this.$element);
    }

    trigger () {
        log('trigger');
        var dataSet = {
            'event' : this.options.event,
            'ecommerce' : {}
        };

        var groupname = {};
        dataSet.ecommerce[this.options.action] = groupname;
        dataSet.ecommerce[this.options.action][this.options.groupname] = Array();

        const data = Object
            .keys(this.options)
            .filter((key) => !['on', 'extractValueAs', 'event','action', 'groupname'].includes(key))
            .reduce((result, key) => {
                if (key.length > 0) {
                    if (key == 'dynamic') {
                        var dynamicData = this.options[key].split(':');
                        var fieldName =dynamicData.length > 0 ? dynamicData[0] : '';
                        var selector =dynamicData.length > 1 ? dynamicData[1] : '';
                        var defaultVal = dynamicData.length > 2 ? dynamicData[2] : '';

                        if (typeof($(selector)) !== 'undefined') {
                            var selectedVal = $(selector).val();
                            result[fieldName] = selectedVal.length > 0 ? selectedVal : defaultVal;
                        }
                    }
                    else {
                        result[key] = this.options[key];
                    }
                }
                return result;
            }, {});

        dataSet.ecommerce[this.options.action][this.options.groupname].push(data);

        log(`trigger.data ${JSON.stringify({dataSet})}`);
        if (typeof(dataLayer) !=='undefined') {
            dataLayer.push(dataSet);
        }

    }
}

CommerceAnalyticsTriggerPlugin.DEFAULTS = {
    on: "click",
    event: 'productClick',
    groupname: 'products',
    action:'click'
};

plugin('commerceAnalyticsTrigger', CommerceAnalyticsTriggerPlugin);

export function exec () {
    $(document).ready(() => {
        log('binding');
        $(ELEMENT_SELECTOR).commerceAnalyticsTrigger();
        log('bound');
    });
}



// WEBPACK FOOTER //
// ./project/client/src/core/modules/commerce-analytics-trigger/index.js